import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, mergeProps as _mergeProps, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "d-flex align-center primary--text justify-space-between" }
const _hoisted_2 = {
  key: 0,
  class: "tag mr-2",
  style: {"opacity":"0.6"}
}
const _hoisted_3 = {
  key: 1,
  class: "tag mr-2",
  style: {"opacity":"0.6"}
}
const _hoisted_4 = {
  key: 0,
  class: "d-flex align-center justify-space-between"
}
const _hoisted_5 = {
  key: 1,
  class: "tag tag-secondary mr-2",
  style: {"opacity":"0.6"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_oss_company_selector = _resolveComponent("oss-company-selector")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_TutorialButtonDialog = _resolveComponent("TutorialButtonDialog")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_AssociatesTable = _resolveComponent("AssociatesTable")!
  const _component_UserEditionLight = _resolveComponent("UserEditionLight")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { flat: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        "no-gutters": "",
        class: "my-3 justify-center"
      }, {
        default: _withCtx(() => [
          (_ctx.companyId)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 0,
                cols: "2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn_primary, {
                    block: "",
                    onClick: _ctx.startCreateUser,
                    id: "Add",
                    "data-cy": "UserTable-add"
                  }, {
                    default: _withCtx(() => _cache[7] || (_cache[7] = [
                      _createTextVNode(" Ajouter ")
                    ])),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_col, {
            class: "pl-2",
            cols: "2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_select, {
                modelValue: _ctx.userType,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userType) = $event)),
                label: "Types de personnes",
                items: _ctx.userTypes,
                "item-value": "value",
                elevation: "0",
                outlined: "",
                "hide-details": "",
                "data-cy": "UserTable-userType",
                density: "compact",
                "item-title": (item) => item.name
              }, null, 8, ["modelValue", "items", "item-title"])
            ]),
            _: 1
          }),
          (_ctx.userTypeSelectable)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createVNode(_component_v_col, {
                  cols: "2",
                  class: "pl-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.selected,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selected) = $event)),
                      items: _ctx.items,
                      "item-value": "value",
                      "item-title": "text",
                      label: "Filtre",
                      outlined: "",
                      "hide-details": "",
                      elevation: "0",
                      "data-cy": "UserTable-selected",
                      density: "compact"
                    }, null, 8, ["modelValue", "items"])
                  ]),
                  _: 1
                }),
                (_ctx.selected === 'users')
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 0,
                      cols: "2",
                      class: "pl-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_oss_company_selector, {
                          modelValue: _ctx.selectedCompanies,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedCompanies) = $event)),
                          multiple: true,
                          items: _ctx.allAvailableCompanies,
                          label: 'Société',
                          "data-cy": "UserTable-selectedCompanies"
                        }, null, 8, ["modelValue", "items"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          _createVNode(_component_v_col, { class: "pl-2" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.search,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.search) = $event)),
                label: "Recherche",
                outlined: "",
                "hide-details": "",
                "data-cy": "UserTable-search",
                density: "compact",
                "append-inner-icon": "$search",
                clearable: "",
                "onClick:clear": _cache[4] || (_cache[4] = ($event: any) => (_ctx.search = ''))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          (!_ctx.$vuetify.display.mobile)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 2,
                cols: "1",
                class: "d-flex justify-end align-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_TutorialButtonDialog, { starterComponents: 'UserTable;' })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createElementVNode("div", {
        style: _normalizeStyle('max-height:' + _ctx.maxHeight + ';' + 'overflow:auto')
      }, [
        (_ctx.userType !== 'ASSOCIATE_USER')
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.users, (item) => {
              return (_openBlock(), _createBlock(_component_v_row, {
                "no-gutters": "",
                class: "d-flex justify-center",
                "data-cy": "UserTable-UsersList",
                key: item.id
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "8" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, {
                        class: "default_card mt-0 mb-4 mx-0",
                        onClick: ($event: any) => (_ctx.editUser(item.id)),
                        style: {"cursor":"pointer"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, {
                            "no-gutters": "",
                            "data-cy": 'UserTable-editUser-' + item.id
                          }, {
                            default: _withCtx(() => [
                              (!_ctx.$vuetify.display.mobile)
                                ? (_openBlock(), _createBlock(_component_v_col, {
                                    key: 0,
                                    cols: "2",
                                    class: "d-flex align-center justify-center"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_avatar, { color: "secondary" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.getUserBigram(item)), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true),
                              _createVNode(_component_v_col, { cols: "8" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_1, [
                                    _createElementVNode("span", {
                                      "data-cy": "UserTable-UserName",
                                      class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'ml-2' : ''),
                                      style: {"font-weight":"bold","font-size":"16pt"}
                                    }, [
                                      _createTextVNode(_toDisplayString(_ctx.getTitle(item)) + " ", 1),
                                      (_ctx.isOwner(item))
                                        ? (_openBlock(), _createBlock(_component_v_chip, {
                                            key: 0,
                                            label: "",
                                            color: "primary",
                                            class: "ml-2",
                                            size: "small",
                                            variant: "outlined"
                                          }, {
                                            default: _withCtx(() => _cache[8] || (_cache[8] = [
                                              _createTextVNode("Propriétaire")
                                            ])),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true)
                                    ], 2),
                                    (item.profile)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.getProfileName(item)), 1))
                                      : (item.type)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.$t("user.type." + item.type)), 1))
                                        : _createCommentVNode("", true)
                                  ]),
                                  (item.email || _ctx.isRootProfile)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                        (item.email)
                                          ? (_openBlock(), _createElementBlock("span", {
                                              key: 0,
                                              class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'ml-2' : ''),
                                              style: {"opacity":"0.6"}
                                            }, _toDisplayString(_ctx.getDisplayEmail(item.email)), 3))
                                          : _createCommentVNode("", true),
                                        (_ctx.isRootProfile)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(item.company && item.company.name
                                                ? item.company.name
                                                : "-"), 1))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_v_col, { cols: "2" }, {
                                default: _withCtx(() => [
                                  (_ctx.userAllowedToModify)
                                    ? (_openBlock(), _createBlock(_component_v_row, {
                                        key: 0,
                                        "no-gutters": ""
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_col, {
                                            cols: _ctx.canUnlinkUser(item) ? 6 : 12,
                                            class: "d-flex justify-center pa-0",
                                            onClick: ($event: any) => (_ctx.editUser(item.id)),
                                            style: {"cursor":"pointer"}
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_tooltip, { location: "bottom" }, {
                                                activator: _withCtx(({ props }) => [
                                                  _createVNode(_component_v_btn_icon, _mergeProps({
                                                    icon: "$edit",
                                                    large: "",
                                                    color: "secondary",
                                                    ref_for: true
                                                  }, props), null, 16)
                                                ]),
                                                default: _withCtx(() => [
                                                  _cache[9] || (_cache[9] = _createElementVNode("span", null, "Modifier", -1))
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 2
                                          }, 1032, ["cols", "onClick"]),
                                          (_ctx.canUnlinkUser(item))
                                            ? (_openBlock(), _createBlock(_component_v_col, {
                                                key: 0,
                                                cols: "6",
                                                class: "d-flex justify-center pa-0",
                                                onClick: _withModifiers(($event: any) => {
                                            _ctx.selectedUser = item;
                                            _ctx.dialogDisconnectUser = true;
                                        }, ["stop"]),
                                                style: {"cursor":"pointer"}
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_tooltip, { location: "bottom" }, {
                                                    activator: _withCtx(({ props }) => [
                                                      _createVNode(_component_v_btn_icon, _mergeProps({
                                                        icon: "$fa-unlink",
                                                        large: "",
                                                        color: "new_red",
                                                        ref_for: true
                                                      }, props, {
                                                        disabled: _ctx.isOwnerSomewhere(item)
                                                      }), null, 16, ["disabled"])
                                                    ]),
                                                    default: _withCtx(() => [
                                                      _createElementVNode("span", null, _toDisplayString(_ctx.isOwnerSomewhere(item)
                                                        ? "Droits non modifiables pour le propriétaire du dossier"
                                                        : "Retirer les droits de connexion"), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1032, ["onClick"]))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["data-cy"])
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024))
            }), 128))
          : (_openBlock(), _createBlock(_component_v_row, {
              key: 1,
              "no-gutters": "",
              class: "d-flex justify-center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_AssociatesTable, { company: _ctx.companyDetails }, null, 8, ["company"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
      ], 4),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.addUserDialog,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.addUserDialog) = $event)),
        actions: _ctx.actions,
        title: 'Création d\'un nouvel utilisateur',
        onValid: _ctx.upsertUser,
        prefixDataCy: "UserTable-create",
        width: "60vw"
      }, {
        default: _withCtx(() => [
          (_ctx.addUserDialog)
            ? (_openBlock(), _createBlock(_component_UserEditionLight, {
                key: 0,
                actions: _ctx.actions,
                id: "Dialog",
                ref: "userEditionLight"
              }, null, 8, ["actions"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue", "actions", "onValid"]),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.dialogDisconnectUser,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.dialogDisconnectUser) = $event)),
        title: 'Retirer les droits de connexion',
        onValid: _ctx.removeUser,
        validTitle: 'Retirer les droits de connexion de cet utilisateur',
        width: "1000px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, { class: "mx-2" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _cache[10] || (_cache[10] = _createTextVNode(" Vous êtes sur le point de retirer les droits de connexion de ")),
                  _createElementVNode("b", null, _toDisplayString(_ctx.getUserDisplayName(_ctx.selectedUser)), 1),
                  _cache[11] || (_cache[11] = _createTextVNode(" à la plateforme. Cet utilisateur ne sera pas supprimé de votre société mais ne pourra plus se connecter. "))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue", "onValid"])
    ]),
    _: 1
  }))
}